/**
 * useIsSuperAdmin Hook
 * Checks if the current user is a super admin based on email whitelist
 * Used to show/hide admin features and protect admin routes
 */
import { useAuth } from "@/global/auth/AuthContext";

const SUPER_ADMIN_EMAILS = [
  'tl@findmyagency.net',
  'info@findmyagency.net',
  'tl@orcasoftware.us',
  'info@orcasoftware.us',
  'info@orcaams.com'
];

export function useIsSuperAdmin() {
  const { user } = useAuth();

  // Check if user's email matches any super admin email (case-insensitive)
  const isSuperAdmin = user?.email 
    ? SUPER_ADMIN_EMAILS.includes(user.email.toLowerCase())
    : false;

  console.log('[useIsSuperAdmin] user:', user?.email);
  console.log('[useIsSuperAdmin] isSuperAdmin:', isSuperAdmin);
  console.log('[useIsSuperAdmin] whitelist:', SUPER_ADMIN_EMAILS);

  return { isSuperAdmin };
}
